export const HEADER = 'Our Partner Programs';
export const DESCRIPTION =
  'Noodle works with top US universities to build and manage online programs. We exclusively work with schools that offer great outcomes for students. Explore below and request more information for any program/s that look interesting!';
export const DISCLAIMER =
  'I acknowledge that I am allowing any schools listed on this site both in the past and in the future to contact me about schools etc.';
